<template>
  <div class="coupon-goods">
    <div class="title">优惠抢购</div>
    <div class="coupon-goods-main" v-loading="loading">
      <div class="good" v-for="(good, index) in goodList" :key="index">
        <a :href="good.detail" target="_blank" class="img-container">
          <img :src="good.img" width="138" height="138" alt="商品图" class="good-img" />
        </a>
        <div class="detail">
          <a :href="good.detail" target="_blank" class="good-name">{{good.name}}</a>
          <span class="good-price">{{good.price}}元</span>
          <span v-if="good.ableSale" class="add-shop-cart" @click="toAddShopCart(good.id)">加入购物车</span>
          <span v-else class="has-saled">商品已售馨</span>
        </div>
      </div>
    </div>
    <div class="pagination-tpl-container">
      <pagination-tpl
        :total="totalNum"
        :pageSize="pageSize"
        :currentPage="currentPage"
        @queryChange="onQueryChange"
      ></pagination-tpl>
    </div>
  </div>
</template>

<script >
import PaginationTpl from 'base/PaginationTpl';
import XBCoupon from 'models/xb/coupon.js';
import ShoppingCart from 'models/xb/shopping-cart.js';
const xbCoupon = new XBCoupon();
const shoppingCart = new ShoppingCart();
const GOOD_IMG_DEFAULT = 'http://image.8844it.com/ydb2/goodDefault.png';
export default {
  data() {
    return {
      // 优惠券能够使用的商品列表
      pageSize: 20,
      totalNum: 0,
      currentPage: 1,
      goodList: [],
      loading: true,
      // 当前域名
      domain: '',
      carDate: 0 // 触发加入购物车
    };
  },
  methods: {
    // 点击加入购物车
    toAddShopCart(goodId) {
      console.log('商品id', goodId);
      let data = {
        goodsId: goodId
      };
      console.log(data);
      this._addGoodToShopCart(data);
    },
    onQueryChange(query) {
      let options = {
        id: this.$route.query.couponId,
        currentPage: query.currentPage
      };
      this._getCommodityListWithCoupon(options);
      window.scrollTo(0, 0);
    },
    // 将商品添加至购物车
    _addGoodToShopCart(data) {
      shoppingCart.postAddShoppingCart(data).then(res => {
        if (res.success) {
          // 添加成功
          this.carDate = new Date().getTime();
          this.$emit('addCart', this.carDate);
          this.$message({
            message: '添加成功！',
            center: true,
            type: 'success',
            duration: 1000
          });
        } else {
          // 添加失败
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    // 根据优惠券Id获取可使用的商品列表
    _getCommodityListWithCoupon(options) {
      xbCoupon.getCommodityListWithCoupon(options).then(res => {
        if (res.success) {
          console.log('可使用优惠券的商品列表', res.result);
          let { totalNum, items, pageSize } = res.result;
          this.totalNum = totalNum;
          this.pageSize = pageSize;
          this.goodList = [];
          items.map(commodity => {
            this.goodList.push({
              id: commodity.id,
              img: commodity.itemImages[0]
                ? commodity.itemImages[0]
                : GOOD_IMG_DEFAULT,
              name: commodity.goodsName,
              price: commodity.defaultPrice,
              detail: `http://${this.domain}/product?id=${commodity.id}`,
              ableSale: Boolean(commodity.saleTotal)
            });
          });
          this.loading = false;
        }
      });
    }
  },
  created() {
    // 根据优惠券id获取可购买商品列表
    this._getCommodityListWithCoupon({
      id: this.$route.query.couponId,
      currentPage: this.currentPage
    });
    // 当前域名
    this.domain = window.location.host;
  },
  components: {
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.coupon-goods {
  font-size: 16px;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    width: 100%;
    height: 100px;
    background: url("../../../assets/coupon-good-list/coupon-good-list-bg-@2x.png")
      center no-repeat;
  }
  .min-height {
    min-height: 800px;
  }
  .coupon-goods-main {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .good {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 20px;
      padding-bottom: 16px;
      &:nth-child(4n + 1) {
        padding-left: 20px;
        padding-right: 0;
      }
      &:nth-child(4n) {
        padding-left: 10px;
        padding-right: 10px;
      }
      &:nth-child(4n-1) {
        padding-left: 10px;
        padding-right: 10px;
      }
      &:nth-child(4n-2) {
        padding-right: 20px;
        padding-bottom: 16px;
      }
      .img-container {
        width: 140px;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        .good-img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .detail {
        box-sizing: border-box;
        width: 140px;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding-left: 12px;
        padding-top: 16px;
        padding-bottom: 16px;
        background: #ffffff;
        .good-name {
          height: 28px;
          width: 100px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 14px;
          font-size: 12px;
          color: #666666;
        }
        .good-price {
          font-size: 14px;
          color: #df3445;
        }
        .add-shop-cart {
          display: inline-block;
          width: 80px;
          height: 26px;
          display: flex;
          background: rgba(223, 52, 69, 0.75);
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #ffffff;
          border-radius: 2px;
          cursor: pointer;
          &:hover {
            background: rgba(223, 52, 69, 1);
          }
        }
        .has-saled {
          display: inline-block;
          width: 80px;
          height: 26px;
          display: flex;
          background: #919398;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #ffffff;
          border-radius: 2px;
          cursor: not-allowed;
        }
      }
    }
  }
  .pagination-tpl-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
